import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import GradientForceCalculator from '../components/tools/GradientForceCalculator';

const GradientForceCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="gradient-force-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Gradient Force Calculator"
        description="Calculate the force acting along a road gradient due to vehicle weight — the component of vehicle weight that must be overcome to climb a graded road, commonly called Gradient Force or Grade Resistance."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="gradient-force-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <GradientForceCalculator />
          <ToolGuideCta guidePath="/tools/gradient-force-calculator/guide" toolName="Gradient Force Calculator" />
        </div>
      </section>
    </div>
  );
};

export default GradientForceCalculatorPage;
